/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import styles from '@app/components/discovery/DiscoverySidebar.module.css';
import {Scroller} from '@app/components/uikit/Scroller';
import DiscoveryStore from '@app/stores/DiscoveryStore';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import {useCallback} from 'react';

export const DiscoverySidebar = observer(function DiscoverySidebar() {
	const {t} = useLingui();

	const handleCategoryClick = useCallback((categoryId: number | null) => {
		void DiscoveryStore.search({category: categoryId, offset: 0});
	}, []);

	return (
		<div className={styles.container}>
			<Scroller showTrack={false}>
				<div className={styles.categoryList}>
					<button
						type="button"
						className={DiscoveryStore.category === null ? styles.categoryItemActive : styles.categoryItem}
						onClick={() => handleCategoryClick(null)}
					>
						{t`All`}
					</button>
					{DiscoveryStore.categories.map((cat) => (
						<button
							key={cat.id}
							type="button"
							className={DiscoveryStore.category === cat.id ? styles.categoryItemActive : styles.categoryItem}
							onClick={() => handleCategoryClick(cat.id)}
						>
							{cat.name}
						</button>
					))}
				</div>
			</Scroller>
		</div>
	);
});
